import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { I18nService, TranslatePipe } from '@recruitee/i18n';

import { ClipboardCopy } from '../../clipboard-copy.service';
import { ButtonComponent } from '../../common/button/components/button/button.component';
import { InputComponent } from '../../forms/input/input.component';

@Component({
  selector: 'rt-copy-text-dropdown',
  templateUrl: './copy-text-dropdown.component.html',
  styleUrls: ['./copy-text-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [InputComponent, ButtonComponent, TranslatePipe],
})
export class CopyTextDropdownComponent {
  @Input() public text: string = '';
  @Output() public edit: EventEmitter<void> = new EventEmitter();

  constructor(
    private clipboardCopy: ClipboardCopy,
    private i18n: I18nService,
  ) {}

  public copyToClipboard(): void {
    this.clipboardCopy.fromString(this.text, this.i18n.translate('app.common.copied'));
  }
}
